import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import React, { createContext, useContext, useState, useEffect } from "react";
import Toast from "../components/Toast";
import { get } from "lodash";
import Store from "../utils/Store";
import { useStoreState } from "pullstate";

// Define the shape of the context

var BASE_URL = process.env.NEXT_PUBLIC_MOBIUS_API_URL;

// Create the context with default values
var HealthWorkerContext = /*#__PURE__*/createContext(undefined);

// Provider component
export var HealthWorkerProvider = function HealthWorkerProvider(_ref) {
  var _get$find;
  var children = _ref.children;
  var _useState = useState({}),
    healthSettings = _useState[0],
    setHealthSettings = _useState[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo
      };
    }),
    userInfo = _useStoreState.userInfo;
  var sourceId = (_get$find = get(userInfo, ["upload_sources"], []).find(function (source) {
    return source.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
  })) === null || _get$find === void 0 ? void 0 : _get$find.uuid;
  useEffect(function () {
    var fetchHealthSettings = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, _data$data, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("".concat(BASE_URL, "/hw-settings/").concat(sourceId));
            case 3:
              response = _context.sent;
              if (!response.ok) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return response.json();
            case 7:
              data = _context.sent;
              setHealthSettings((data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.settings) || {});
            case 9:
              _context.next = 15;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.error("Error fetching health settings:", _context.t0);
              Toast.error("Failed to fetch health settings!");
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }));
      return function fetchHealthSettings() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (sourceId) {
      fetchHealthSettings();
    }
  }, [sourceId]);
  return /*#__PURE__*/React.createElement(HealthWorkerContext.Provider, {
    value: {
      healthSettings: healthSettings,
      setHealthSettings: setHealthSettings
    }
  }, children);
};

// Custom hook for using the counter context
export var useHealthWorker = function useHealthWorker() {
  var context = useContext(HealthWorkerContext);
  if (context === undefined) {
    throw new Error("useHealthWorker must be used within a HealthWorkerProvider");
  }
  return context;
};